export default {
  name: 'devconfig',
  items: [{
    name: 'aspectRatio',
    type: 'switch',
    text: '保持长宽比',
    onChange(vm, v, { formValue }) {
      if (!v) return;
      // eslint-disable-next-line no-param-reassign
      formValue.devconfig.ratio = formValue.style.height / formValue.style.width;
    },
  }, {
    name: 'ratio',
    type: 'hidden',
  }, {
    name: 'resizable',
    type: 'hidden',
  }, {
    name: 'pack',
    type: 'hidden',
  }, {
    name: 'lock',
    type: 'hidden',
  }],
};
